/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { GeoCitiesByCapResponse } from '../models/geo-cities-by-cap-response';
import { GeoCitiesResponse } from '../models/geo-cities-response';
import { geoControllerGetCities } from '../fn/geo/geo-controller-get-cities';
import { GeoControllerGetCities$Params } from '../fn/geo/geo-controller-get-cities';
import { geoControllerGetCitiesByCap } from '../fn/geo/geo-controller-get-cities-by-cap';
import { GeoControllerGetCitiesByCap$Params } from '../fn/geo/geo-controller-get-cities-by-cap';
import { geoControllerGetProvince } from '../fn/geo/geo-controller-get-province';
import { GeoControllerGetProvince$Params } from '../fn/geo/geo-controller-get-province';
import { geoControllerGetProvinces } from '../fn/geo/geo-controller-get-provinces';
import { GeoControllerGetProvinces$Params } from '../fn/geo/geo-controller-get-provinces';
import { geoControllerGetProvincesByRegion } from '../fn/geo/geo-controller-get-provinces-by-region';
import { GeoControllerGetProvincesByRegion$Params } from '../fn/geo/geo-controller-get-provinces-by-region';
import { geoControllerGetRegion } from '../fn/geo/geo-controller-get-region';
import { GeoControllerGetRegion$Params } from '../fn/geo/geo-controller-get-region';
import { geoControllerGetRegions } from '../fn/geo/geo-controller-get-regions';
import { GeoControllerGetRegions$Params } from '../fn/geo/geo-controller-get-regions';
import { GeoProvincesByRegionResponse } from '../models/geo-provinces-by-region-response';
import { GeoProvincesResponse } from '../models/geo-provinces-response';
import { GeoRegionListResponse } from '../models/geo-region-list-response';
import { ItalyProvinceItem } from '../models/italy-province-item';
import { ItalyRegionItem } from '../models/italy-region-item';

@Injectable({ providedIn: 'root' })
export class GeoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `geoControllerGetRegions()` */
  static readonly GeoControllerGetRegionsPath = '/geo/italy/region';

  /**
   * Restituisce l'elenco delle Regioni (Italia).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geoControllerGetRegions()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetRegions$Response(params?: GeoControllerGetRegions$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoRegionListResponse;
}>> {
    return geoControllerGetRegions(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle Regioni (Italia).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geoControllerGetRegions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetRegions(params?: GeoControllerGetRegions$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GeoRegionListResponse;
}> {
    return this.geoControllerGetRegions$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GeoRegionListResponse;
}>): BaseResponse & {
'data'?: GeoRegionListResponse;
} => r.body)
    );
  }

  /** Path part for operation `geoControllerGetRegion()` */
  static readonly GeoControllerGetRegionPath = '/geo/italy/region/{id}';

  /**
   * Restituisce una Regione (Italia).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geoControllerGetRegion()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetRegion$Response(params: GeoControllerGetRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ItalyRegionItem;
}>> {
    return geoControllerGetRegion(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una Regione (Italia).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geoControllerGetRegion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetRegion(params: GeoControllerGetRegion$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ItalyRegionItem;
}> {
    return this.geoControllerGetRegion$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ItalyRegionItem;
}>): BaseResponse & {
'data'?: ItalyRegionItem;
} => r.body)
    );
  }

  /** Path part for operation `geoControllerGetProvincesByRegion()` */
  static readonly GeoControllerGetProvincesByRegionPath = '/geo/italy/region/{id}/province';

  /**
   * Restituisce le Province di una Regione (Italia).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geoControllerGetProvincesByRegion()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetProvincesByRegion$Response(params: GeoControllerGetProvincesByRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoProvincesByRegionResponse;
}>> {
    return geoControllerGetProvincesByRegion(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le Province di una Regione (Italia).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geoControllerGetProvincesByRegion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetProvincesByRegion(params: GeoControllerGetProvincesByRegion$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GeoProvincesByRegionResponse;
}> {
    return this.geoControllerGetProvincesByRegion$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GeoProvincesByRegionResponse;
}>): BaseResponse & {
'data'?: GeoProvincesByRegionResponse;
} => r.body)
    );
  }

  /** Path part for operation `geoControllerGetProvinces()` */
  static readonly GeoControllerGetProvincesPath = '/geo/italy/province';

  /**
   * Restituisce tutte le Province (Italia).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geoControllerGetProvinces()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetProvinces$Response(params?: GeoControllerGetProvinces$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoProvincesResponse;
}>> {
    return geoControllerGetProvinces(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce tutte le Province (Italia).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geoControllerGetProvinces$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetProvinces(params?: GeoControllerGetProvinces$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GeoProvincesResponse;
}> {
    return this.geoControllerGetProvinces$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GeoProvincesResponse;
}>): BaseResponse & {
'data'?: GeoProvincesResponse;
} => r.body)
    );
  }

  /** Path part for operation `geoControllerGetProvince()` */
  static readonly GeoControllerGetProvincePath = '/geo/italy/province/{id}';

  /**
   * Restituisce una Provincia e tutti i suoi Comuni (Italia).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geoControllerGetProvince()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetProvince$Response(params: GeoControllerGetProvince$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ItalyProvinceItem;
}>> {
    return geoControllerGetProvince(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una Provincia e tutti i suoi Comuni (Italia).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geoControllerGetProvince$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetProvince(params: GeoControllerGetProvince$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ItalyProvinceItem;
}> {
    return this.geoControllerGetProvince$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ItalyProvinceItem;
}>): BaseResponse & {
'data'?: ItalyProvinceItem;
} => r.body)
    );
  }

  /** Path part for operation `geoControllerGetCities()` */
  static readonly GeoControllerGetCitiesPath = '/geo/italy/city';

  /**
   * Restituisce un elenco di Comuni (Italia).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geoControllerGetCities()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetCities$Response(params: GeoControllerGetCities$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoCitiesResponse;
}>> {
    return geoControllerGetCities(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un elenco di Comuni (Italia).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geoControllerGetCities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetCities(params: GeoControllerGetCities$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GeoCitiesResponse;
}> {
    return this.geoControllerGetCities$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GeoCitiesResponse;
}>): BaseResponse & {
'data'?: GeoCitiesResponse;
} => r.body)
    );
  }

  /** Path part for operation `geoControllerGetCitiesByCap()` */
  static readonly GeoControllerGetCitiesByCapPath = '/geo/italy/by-cap/{cap}';

  /**
   * Restituisce i Comuni corrispondenti a un CAP (Italia).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geoControllerGetCitiesByCap()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetCitiesByCap$Response(params: GeoControllerGetCitiesByCap$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoCitiesByCapResponse;
}>> {
    return geoControllerGetCitiesByCap(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i Comuni corrispondenti a un CAP (Italia).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geoControllerGetCitiesByCap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geoControllerGetCitiesByCap(params: GeoControllerGetCitiesByCap$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GeoCitiesByCapResponse;
}> {
    return this.geoControllerGetCitiesByCap$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GeoCitiesByCapResponse;
}>): BaseResponse & {
'data'?: GeoCitiesByCapResponse;
} => r.body)
    );
  }

}
